import React, { useEffect } from 'react';
import {Route, Routes, useNavigate} from 'react-router-dom';
import {TaiLieu} from './tai-lieu';
import {TaiLieuDaGui} from './tai-lieu-da-gui/';
import {TaiLieuDaNhan} from './tai-lieu-da-nhan';
import {TaiLieuNhap} from './tai-lieu-nhap';
import {ThungRac} from './thung-rac';
import {TaiLieuKy} from './tai-lieu-ky';
import { GoogleService } from './GoogleService';

const TaoTaiLieuCommand: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await GoogleService.createEmpty();
        if (!cancelled && res && res.agreementId) {
          navigate(`/quan-ly-tai-lieu/tai-lieu/${res.agreementId}`, { replace: true });
        }
      } catch (e) {
        // ignore
      }
    })();
    return () => { cancelled = true; };
  }, [navigate]);
  return (<div className="p-3">Đang tạo tài liệu...</div>);
};

export default function QuanLyTaiLieu() {
  return (
    <Routes>
      <Route path="tai-lieu" element={<TaoTaiLieuCommand/>}/>
      <Route path="tai-lieu/:agreementId" element={<TaiLieu/>}/>
      <Route path="tai-lieu-den" element={<TaiLieuDaNhan/>}/>
      <Route path="tai-lieu-da-nhan" element={<TaiLieuDaNhan/>}/>
      <Route path="tai-lieu-da-gui" element={<TaiLieuDaGui/>}/>
      <Route path="tai-lieu-quan-ly" element={<TaiLieuKy/>}/>
      <Route path="tai-lieu-nhap" element={<TaiLieuNhap/>}/>
      <Route path="thung-rac" element={<ThungRac/>}/>
    </Routes>
  );
}
